// Generate TLDR from content
export const generateTLDR = (content: string): string => {
  // Remove HTML tags and clean up
  const cleanContent = content
    .replace(/<[^>]*>/g, '')
    .replace(/\*\*/g, '')
    .replace(/###/g, '')
    .replace(/##/g, '')
    .replace(/#/g, '')
    .replace(/\\n/g, ' ')
    .replace(/\n/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  
  // Split into sentences and take the first 2-3 key sentences
  const sentences = cleanContent.split(/[.!?]+/).filter(s => s.trim().length > 10);
  
  // Find sentences with actionable keywords
  const actionKeywords = ['start', 'try', 'use', 'create', 'implement', 'practice', 'focus', 'avoid', 'consider', 'remember', 'invest', 'buy', 'sell', 'analyze', 'research'];
  const keySentences = sentences.filter(sentence => 
    actionKeywords.some(keyword => sentence.toLowerCase().includes(keyword))
  ).slice(0, 2);
  
  // If we don't have enough action sentences, take the first few sentences
  if (keySentences.length < 2) {
    return sentences.slice(0, 2).join('. ').trim() + '.';
  }
  
  return keySentences.join('. ').trim() + '.';
};